import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';

export default function DaysSelector({ value, onChange }) {
  const days = [1, 2, 3, 4, 5, 6, 7];

  return (
    <div className="space-y-3">
      <label className="block text-sm font-semibold text-slate-700">Training Days Per Week</label>
      <div className="flex gap-2 flex-wrap">
        {days.map((day) => (
          <motion.button
            key={day}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            type="button"
            onClick={() => onChange(day)}
            className={cn(
              'relative w-12 h-12 rounded-xl font-bold text-lg transition-all duration-300',
              'border-2',
              value === day
                ? 'border-orange-400 text-white shadow-lg shadow-orange-200'
                : 'border-slate-200 text-slate-600 hover:border-orange-200 bg-white',
            )}
          >
            {value === day && (
              <motion.div
                layoutId="daySelector"
                className="absolute inset-0 rounded-xl bg-gradient-to-br from-orange-400 to-amber-500"
                initial={false}
                transition={{ type: 'spring', bounce: 0.2, duration: 0.6 }}
              />
            )}
            <span className="relative z-10">{day}</span>
          </motion.button>
        ))}
      </div>
      <p className="text-xs text-slate-500">
        {value <= 2 && 'Perfect for beginners or busy schedules'}
        {value >= 3 && value <= 4 && 'Balanced training frequency'}
        {value >= 5 && 'Intensive training schedule'}
      </p>
    </div>
  );
}
